import { Routes, Route } from 'react-router-dom';

import { RequiresAuth } from '~/components/Auth';
import { Layout } from '~/components/Layout';

import routes from '../config/routesConfig';

import NoRemoteRouteMatched from './NoMatchingRoute';
import LegacyAppRouting from '~/components/LegacyAppRouting';
import { WgllLibrary, OrgReadiness } from '~/components/LegacyAppRouting/components/WGLL';
import { isAdminSite } from '~/utils';
import { ROUTE_TYPES } from '../config/constants';
import { renderRoutes } from '../helpers';

const ProtectedRoutes = () => (
  <RequiresAuth>
    <Layout>
      <Routes>
        {renderRoutes(routes, ROUTE_TYPES.protectedRoutes)}
        {!isAdminSite() && <Route path="learner/*" element={<LegacyAppRouting />} />}
        {isAdminSite() && <Route path="account-settings/wgll" element={<WgllLibrary />} />}
        {isAdminSite() && <Route path="analytics/wgll-readiness" element={<OrgReadiness />} />}
        <Route path="*" element={<NoRemoteRouteMatched />} />
      </Routes>
    </Layout>
  </RequiresAuth>
);

export default ProtectedRoutes;
